export const loaderTransitionDurationMs = 600;
